export const urls = {
  login: "/login",
  forget_password: "/forget_password",
  /** 寄給總監的 onboarding 連結：設定 Admin PIN */
  admin_pin_setup: "/admin-pin-setup",
  /** 設過 Admin PIN 的帳號登入後選身分：Admin（要 PIN）或一般使用者 */
  select_profile: "/select-profile",
  registration: "/registration",
  plan: "/choosing_plan",
  interior_plan: "/choosing_interior_plan",
  demo: {
    chat: "/genie_demo/chat",
    design_brief: "/genie_demo/design_brief/:identifyKey",
    reference_image: "/genie_demo/reference_image/:identifyKey",
    mood_board: "/genie_demo/mood_board",
  },
  design_genie: {
    home: "/genie/:userLinkWords",
    chat: "/genie/:userLinkWords/chat",
    reference_image: "/genie/:userLinkWords/reference_image/:identifyKey",
    design_brief: "/genie/:userLinkWords/design_brief/:identifyKey",
    book: "/genie/book",
    thank_you: "/genie/:userLinkWords/thank_you",
  },
  admin: {
    dashboard: "/client_request",
    knowledge_base: "/knowledge-base",
    pricing_kb: "/pricing-knowledge-base",
    pricing_kb_detail: "/pricing-knowledge-base/:kbId",
    presentation_templates: "/presentation-templates",
    knowledge_base_case: "/knowledge-base/:caseId",
    client: "/client_request/:clientId",
    shared_overview: "/client_request/:identifyKey/overview",
    shared_suggestions: "/client_request/:identifyKey/suggestions",
    shared_history: "/client_request/:identifyKey/history",
    shared_brand_analysis: "/client_request/:identifyKey/analysis",
    shared_estimate: "/client_request/:identifyKey/estimate",
    shared_estimate_v2: "/client_request/:identifyKey/estimate_v2",
    account: "/account",
    account_know_how: "/account/know_how",
    account_info_edit: "/account/info/edit",
    account_portfolio_create: "/account/portfolio/create",
    account_portfolio_edit: "/account/portfolio/:portfolioId/edit",
    account_works_create: "/account/works/create",
    account_works_edit: "/account/works/:workId/edit",
    account_password_edit: "/account/password/edit",
    account_chatbot_color_edit: "/account/chatbot_color/edit",
    account_sub_account: "/account/sub-account",
    demo: "/client_request_demo",
    demo_shared_overview: "/client_request_demo/overview",
    demo_shared_suggestions: "/client_request_demo/suggestions",
    demo_shared_history: "/client_request_demo/history",
    admin_dashboard: "/account/admin/dashboard",
  },
  embed: {
    entry: "/genie-embed/:userLinkWords/",
    root: "/genie-embed/:userLinkWords/genie",
    home: "/genie-embed/:userLinkWords/genie/home",
    chat: "/genie-embed/:userLinkWords/genie/chat",
    reference_image:
      "/genie-embed/:userLinkWords/genie/reference_image/:identifyKey",
    design_brief: "/genie-embed/:userLinkWords/genie/design_brief/:identifyKey",
    thank_you: "/genie-embed/:userLinkWords/genie/thank_you",
  },
  outer_plan: {
    normal_design: "/plan",
    interior_design: "/interior_plan",
  },
  mood_board: {
    home: "/mood_board/:userLinkWords",
    chat: "/mood_board/:userLinkWords/chat",
    reference_image: "/mood_board/:userLinkWords/reference_image/:identifyKey",
    design_brief: "/mood_board/:userLinkWords/design_brief/:identifyKey",
    thank_you: "/mood_board/:userLinkWords/thank_you",
    chat_o3_mini: "/mood_board/:userLinkWords/chat_o3_mini",
    chat_imagen3: "/mood_board/:userLinkWords/chat_imagen3",
  },
  embed_mood_board: {
    root: "/genie-embed/:userLinkWords/mood-board",
    home: "/genie-embed/:userLinkWords/mood-board/home",
    chat: "/genie-embed/:userLinkWords/mood-board/chat",
    reference_image:
      "/genie-embed/:userLinkWords/mood-board/reference_image/:identifyKey",
    design_brief:
      "/genie-embed/:userLinkWords/mood-board/design_brief/:identifyKey",
    thank_you: "/genie-embed/:userLinkWords/mood-board/thank_you",
  },
  moodBoard: "/mood_board/:userLinkWords",
  moodBoardv2: "/mood_board_v2/:userLinkWords",
  moodBoardv3: "/mood_board_v3/:userLinkWords",
};
